import WebTheme from "./WebTheme";
import BottomNavigation from '@mui/material/BottomNavigation';
import {BottomNavigationAction} from "@mui/material";
import CookieIcon from '@mui/icons-material/CookieTwoTone';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTipTwoTone';
import PanToolAltIcon from '@mui/icons-material/PanToolAltTwoTone';

export default function Footer({estilo,modo,margen})
{
    console.log("En footer estilo: ",estilo);
    const estiloFooter = {
        background: (estilo.background === 'black') ? WebTheme.colors.backgroundDark : WebTheme.colors.backgroundGreen,
    }

    function navigationOnClick(ev,arg)
    {
        if(arg === 'cookies') {
            window.location = '/cookiesPolicy?modo=' + modo;
        }
        else if(arg === 'privacy') {
            alert('En construcción');
            window.location = '/?modo=' + modo;
        }
        else if(arg === 'to top') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    return(
        <BottomNavigation style={{bottom:'0px' ,left:'0px'}} showLabels={true}
                          sx={{gap:15,
                              boxShadow:24,
                              width:'96%',
                              background:estiloFooter.background,
                              mt:(margen)?margen:0,
                              ml:'2%'}} >
            {<BottomNavigationAction onClick={(e) => {
                navigationOnClick(e,'cookies');
            }} label={'política de cookies'} icon={<CookieIcon  sx={{fontSize:WebTheme.fontSizes.grande}} className={'footerIcons'}/>}></BottomNavigationAction>}
            {<BottomNavigationAction onClick={(e) => {
                navigationOnClick(e,'privacy');
            }} label={'política de privacidad'} icon={<PrivacyTipIcon  sx={{fontSize:WebTheme.fontSizes.grande}} className={'footerIcons'}/>}></BottomNavigationAction>}
            {<BottomNavigationAction onClick={(e) => {
                navigationOnClick(e,'to top');
            }} label={'Ir arriba'} icon={<PanToolAltIcon  sx={{fontSize:WebTheme.fontSizes.grande}} className={'footerIcons'}/>}></BottomNavigationAction>}

        </BottomNavigation>
    )
}